module.exports = __webpack_public_path__ + "static/img/img-1.195dc84f.png";